import createTableStore from "ds/components/Table/store/useTableStore";

import { STACKS_COLUMN_CONFIG, STACKS_COLUMNS_STORAGE_KEY } from "./constants";

const useStacksTableStore = createTableStore({
  storageKey: STACKS_COLUMNS_STORAGE_KEY,
  config: STACKS_COLUMN_CONFIG,
  version: 3,
});

export default useStacksTableStore;
